import styled from "styled-components";
import { Colors } from "../../../shared/colors/colors";
import { StyleSheet } from "@react-pdf/renderer";
import { Fonts } from "../../../shared/fonts/fonts";

export const Container = styled.div`
  display: flex;
  width: 90vw;
  flex-direction: column;
  height: 100%;
  gap: 16px;
  margin-bottom: 16px;
`;

export const ContainerButton = styled.div`
  display: flex;
  margin-left: auto;
  gap: 16px;
`;

export const AppliedFiltersWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 90vw;
  min-height: 48px;
  align-items: center;
  padding: 8px 16px;
  gap: 16px;
  border-radius: 8px;
  border: 1px solid rgba(229, 231, 235, 1);
  background: rgba(249, 250, 251, 1);
  box-sizing: border-box;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: rgba(107, 114, 128, 1);
`;
export const FilterTitle = styled.p`
  margin: 0;
  white-space: nowrap;
`;

export const FiltersContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
`;

export const FilterItem = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  border: 2px solid rgba(147, 197, 253, 1);
  border-radius: 4px;
  padding: 4px 8px;
  background-color: rgba(239, 246, 255, 1);
`;

export const FilterKey = styled.span`
  font-family: "Work Sans", sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-align: left;
`;

export const FilterValue = styled.span`
  font-family: "Work Sans", sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  text-align: left;
`;

export const RemoveButton = styled.button`
  background: none;
  border: none;
  font-weight: bold;
  font-size: 16px;
  cursor: pointer;
  padding: 0;

  img {
    width: 12px;
    height: 12px;
  }
`;


export const LabelCheckbox = styled.label`
  border-collapse: collapse;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.4px;
  font-weight: 600;
  color: ${Colors.label};
  font-family: ${Fonts.primary};
`;

export const ContainerCheckbox = styled.div`
  display: flex;
  align-items: center;
`;

export const RelatorioStyles = StyleSheet.create({
  page: { padding: 30, position: "relative" },

  // Cabeçalho
  header: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 20,
    position: "relative",
  },
  logoContainer: {
    position: "absolute",
    left: 40,
    top: 0,
    width: 45,
    height: 45,
  },
  logo: {
    width: 45,
    height: 45,
  },
  headerText: {
    flex: 1,
    alignItems: "center",
  },
  institution: { fontSize: 12, fontWeight: "bold" },
  details: { fontSize: 10 },
  title: { fontSize: 14, fontWeight: "bold", marginTop: 10 },

  // Filtros
  filtersMainContainer: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    height: "auto",
    width: "auto",
    marginLeft: 53.5,
  },
  filters: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    marginTop: 8,
    gap: 8,
  },
  filterContainer: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    gap: 5,
  },
  filterTextBold: {
    fontSize: 12,
    fontWeight: "bold",
  },
  filterText: {
    fontSize: 12,
  },

  // Tabela
  table: {
    display: "flex",
    width: "auto",
    marginTop: 20,
    alignItems: "center",
  },
  tableContainerSummary: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "18px",
    alignItems: "flex-end",
  },

  tableSummary: {
    width: "90%"
  },
  row: { flexDirection: "row" },
  tableFichas: { display: "flex", width: "auto", marginTop: 20 },
  rowFichas: { flexDirection: "row" },
  cellHeader: {
    fontWeight: "bold",
    padding: 5,
    width: "20%",
    fontSize: 10,
    backgroundColor: Colors.backgroundColorTable,
    border: `1px solid ${Colors.black}`,
  },
  cellHeaderFichas: {
    fontWeight: "bold",
    padding: 5,
    width: "14%",
    fontSize: 8,
    backgroundColor: Colors.backgroundColorTable,
    border: `1px solid ${Colors.black}`,
  },
  cell: {
    padding: 5,
    width: "20%",
    fontSize: 10,
    border: `1px solid ${Colors.black}`,
  },
  cellResume: {
    padding: 5,
    width: "20%",
    fontSize: 10,
    border: `1px solid ${Colors.black}`,
    fontWeight: "normal",
  },
  cellBoldResume: {
    padding: 5,
    width: "20%",
    fontSize: 10,
    border: `1px solid ${Colors.black}`,
    fontWeight: "bold",
  },


  cellFichas: {
    padding: 5,
    width: "14%",
    fontSize: 7,
    border: `1px solid ${Colors.black}`,
  },
  cellEmpty: {
    padding: 5,
    width: "100%",
    fontSize: 7,
    border: `1px solid ${Colors.black}`,
  },
  cellName: {
    padding: 5,
    width: "34%",
    fontSize: 8,
    border: `1px solid ${Colors.black}`,
  },
  cellHeaderName: {
    fontWeight: "bold",
    padding: 5,
    width: "34%",
    fontSize: 8,
    backgroundColor: Colors.backgroundColorTable,
    border: `1px solid ${Colors.black}`,
  },

  cellBold: {
    padding: 5,
    width: "14%",
    fontSize: 7,
    border: `1px solid ${Colors.black}`,
    fontWeight: "bold",
  },
  cellFourSpace: {
    padding: 5,
    width: "76%",
    fontSize: 7,
    border: `1px solid ${Colors.black}`,
  },

  // Rodapé
  footer: {
    position: "absolute",
    bottom: 20,
    left: 30,
    right: 30,
    fontSize: 9,
    flexDirection: "row",
    justifyContent: "space-between",
    color: "#555",
  },
});
